
const debounce = require('lodash/debounce');
const constants = require('../constants');

const endpoint = $('.suggestions-wrapper').data('url');
const minChars = 3;
const UP_KEY = 38;
const DOWN_KEY = 40;
const DIRECTION_DOWN = 1;
const DIRECTION_UP = -1;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).parents('form').siblings('.suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.site-search').length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    const mobileSearchIcon = '.search-mobile button.';
    const iconSearch = 'fa-search';
    const iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    let outerHeight;
    let $scope;
    let $suggestions;

    if (isMobileSearch(scope) || (window.outerWidth < constants.viewport_bootstrap.md)) {
        $scope = $(scope);
        const searchWrapper = $scope.parents('header');

        const siteSearchWrapper = $('.site-search-wrapper');
        const staticSuggestions = $('.static-content-suggestions');
        const staticSuggestionsHeight = staticSuggestions.length
            && staticSuggestions.is(':visible')
            && !siteSearchWrapper.length
            ? staticSuggestions.outerHeight() : 0;

        outerHeight = searchWrapper.outerHeight();
        $suggestions = getSuggestionsWrapper(scope);
        $suggestions.css('top', outerHeight - staticSuggestionsHeight);
        staticSuggestions.css('top', `${outerHeight}px`);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(() => {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    const $suggestionsWrapper = getSuggestionsWrapper(this).empty();
    const staticSuggestions = $('.static-content-suggestions');

    const overlay = $('.site-search-wrapper').find('.overlay');

    if (overlay.length && overlay.css('display') === 'block') {
        overlay.css('display', 'none');
    }

    if (!(typeof (response) === 'object')) {
        const replacePattern = $('.row-grid').hasClass('two-column-grid') ? `${/col-6/g}` : `${/col-6 col-md-3/g}`;
        const responseProcessed = response.replace(replacePattern, 'col-12 p-0');
        if (staticSuggestions.length) {
            staticSuggestions.fadeOut('fast');
        }
        $suggestionsWrapper.append(responseProcessed).fadeIn();
        $(this).siblings('.reset-button').addClass('d-sm-block');
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        const suggestionsList = $('.suggestions .item');
        const searchInput = $('input.search-field');
        if ($(suggestionsList).length) {
            searchInput.attr('aria-describedby', 'search-result-count');
        } else {
            searchInput.removeAttr('aria-describedby');
        }
    } else if (staticSuggestions.length) {
        staticSuggestions.fadeIn('fast');
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    const suggestionsWrapper = $('.suggestions-wrapper');
    if ($(scope).val().length >= minChars
        || suggestionsWrapper.attr('data-showemptyresponse') === 'true') {
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: () => {},
        });
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP
 * (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    const suggestionsList = $('.suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each((e) => {
            $(e.currentTarget).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each((index, value) => {
            const idx = index + direction;

            if ($(value).hasClass('selected')) {
                $(value).removeClass('selected');
                $(value).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(value).removeProp('aria-selected');
                    $('input.search-field').each(() => {
                        $(value).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(() => {
                        $(value).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

module.exports = () => {
    $('form[name="simpleSearch"]').submit((e) => {
        const suggestionsList = $('.suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    const debounceSuggestions = debounce(getSuggestions, 500);
    $('input.search-field').on('keyup focus', function (e) {
        // Capture Down/Up Arrow Key Events
        switch (e.which) {
        case DOWN_KEY:
            handleArrow(DIRECTION_DOWN);
            e.preventDefault(); // prevent moving the cursor
            break;
        case UP_KEY:
            handleArrow(DIRECTION_UP);
            e.preventDefault(); // prevent moving the cursor
            break;
        default:
            debounceSuggestions(this, e);
        }
    });

    $('body').on('click touchend', '.search-mobile button.fa-close', (e) => {
        e.preventDefault();
        $('.suggestions').hide();
        toggleSuggestionsIcon('search');
        tearDownSuggestions();
    });

    $('.site-search .reset-button').on('click', function () {
        $(this).removeClass('d-sm-block');
    });
};
